import { get } from "@/stores/dataManager/axios/axiosIndex";
import { ALL_INDEXES, axiosType } from "../../dataStore/memoryStore/const/constIndex"
import { getConfigFromWindowBrowser } from "@/utilities/utils";
import { ENV } from "@/utilities/EWindow";
import { buildQueryString } from "@/utilities";

const API_MARKET_URL = getConfigFromWindowBrowser(ENV.API_MARKET_URL)
const API = getConfigFromWindowBrowser(ENV.BASE_URL) ?? ''

const apiType = axiosType.CLIENT

// export function getSymbolInfoAll(source: { token: any; } | undefined, config: { pwa: boolean }) {
//     const options = {
//         cancelToken: source?.token,
//     }
//     return get(apiType, `${API_MARKET_URL}/datafeed/instruments`, options, config);
// }

const datafeedService = {
    // api instruments rut gon cac truong thong tin
    getSymbolInfo(params: { config?: object } | any) {
        // console.log('getSymbolInfo: get api', new Date().getTime())
        const options: any = {}
        const config: any = params?.config
        return get(apiType, `${API_MARKET_URL}/datafeed/instruments?brief=false`, options, config);
    },
    // api instruments day du thong tin
    getSymbolInfoAll(source: { token: any; } | undefined, config: { pwa: boolean }) {
        const options = {
            cancelToken: source?.token,
        }
        return get(apiType, `${API_MARKET_URL}/datafeed/instruments`, options, config);

    },
    // api instruments theo san
    getInstrumentsByExchange(params: { config?: object, exchange: string }) {
        // console.log('getInstrumentsByExchange: get api', new Date().getTime())
        const options: any = {}
        const config: any = params?.config
        const exchange = params?.exchange
        // console.log("getInstruments.:", apiType, API_MARKET_URL)
        return get(apiType, `${API_MARKET_URL}/datafeed/instruments?exchange=${exchange}`, options, config);
    },

    getInstrumentsBySymbols(params: { config?: object, symbols: string }) {
        // console.log('getInstrumentsByExchange: get api', new Date().getTime())
        const options: any = {}
        const config: any = params?.config
        const symbols = params?.symbols
        // console.log("getInstruments.:", apiType, API_MARKET_URL)
        return get(apiType, `${API_MARKET_URL}/datafeed/instruments?symbols=${symbols}`, options, config);
    },

    // snapshot market info
    getSnapShotIndexesInfo(params: { config?: object, code: string } | any) {
        const options: any = {}
        const config: any = params?.config
        let codes = params.code
        if (!codes) {
            codes = ALL_INDEXES.map((element: any) => {
                return element.code
            })
        }
        return get(apiType, `${API_MARKET_URL}/datafeed/indexsnaps/` + codes.toString(), options, config);
    },

    // snapshot market index
    getMarketHistory(params: { config?: object, symbols: string }) {
        const options: any = {}
        const config: any = params?.config
        let codes = params.symbols
        if (!codes) {
            codes = ALL_INDEXES.map((element: any) => {
                return element.code
            }).toString()
        }
        if (!params?.symbols) {

        }
        return get(apiType, `${API_MARKET_URL}/datafeed/chartinday/${codes}`, options, config);
    },

    //
    getIndustrySymbol(params: {
        config?: any,
    }) {
        const options: any = {};
        const config: any = params?.config;
        return get(apiType, `${API}/userdata/industry`, options, config);
    },

    getQuoteSymbol(params: {
        config?: any,
        symbols: string[]
    }) {
        const options: any = {};
        const config: any = params?.config;
        const query = buildQueryString({
            symbols: params?.symbols.join(','),
        })
        return get(apiType, `${API}/trade/quotes?${query}`, options, config);
    },
};

export default datafeedService;